import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { EndocrineQuestionnaireItem } from './questionnaire'

export const ENDOCRINE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [EndocrineQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_WNL]:
    QuestionnaireAnswerType.STRING,
  [EndocrineQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_CYCLE]:
    QuestionnaireAnswerType.STRING,
  [EndocrineQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_DATE]:
    QuestionnaireAnswerType.DATE,
  [EndocrineQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [EndocrineQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
